import { render, staticRenderFns } from "./_result.vue?vue&type=template&id=c45f2658&lang=pug&"
import script from "./_result.vue?vue&type=script&lang=js&"
export * from "./_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports